import { DefaultState } from 'store/reducers/types';

export const READ_PERFORMANCE_DATA_REQUEST = "READ_PERFORMANCE_DATA_REQUEST";
export const READ_PERFORMANCE_DATA_SUCCESS = "READ_PERFORMANCE_DATA_SUCCESS";
export const READ_PERFORMANCE_DATA_FAILURE = "READ_PERFORMANCE_DATA_FAILURE";

export interface PerformanceData {
  assignedTD: number;
  assignedYD: number;
  assignedTW: number;
  assignedLW: number;
  assignedTM: number;
  assignedLM: number;
  calledTD: number;
  calledYD: number;
  calledTW: number;
  calledLW: number;
  calledTM: number;
  calledLM: number;
}

export type PerformanceState = DefaultState & {
  contents?: PerformanceData;
}

interface ReadPerformanceDataRequest {
  type: typeof READ_PERFORMANCE_DATA_REQUEST;
};

interface ReadPerformanceDataSuccess {
  type: typeof READ_PERFORMANCE_DATA_SUCCESS;
  contents: PerformanceData
}

interface ReadPerformanceDataFailure {
  type: typeof READ_PERFORMANCE_DATA_FAILURE;
}

export type PerformanceActionTypes = ReadPerformanceDataRequest | ReadPerformanceDataSuccess | ReadPerformanceDataFailure;